(() => {
  const instances = window.__arcaDirectCarousels || (window.__arcaDirectCarousels = new WeakMap());
  function init(root) {
    if (instances.has(root)) return;
    const slides = [...root.querySelectorAll('[data-ad-slide]')];
    const dots = [...root.querySelectorAll('[data-ad-slide-to]')];
    const toggle = root.querySelector('[data-ad-autoplay]');
    if (slides.length < 2 || !toggle) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let paused = motion.matches;
    let hovered = false;
    let focused = false;
    let onScreen = true;
    let timer = null;
    const visible = () => !document.hidden;
    function show(index) {
      current = (index + slides.length) % slides.length;
      root.dataset.activeSlide = String(current + 1);
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', String(i !== current));
      });
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-pressed', String(i === current));
      });
    }
    function sync() {
      window.clearInterval(timer);
      timer = null;
      toggle.setAttribute('aria-label', paused ? 'Reanudar cambio de imágenes' : 'Pausar cambio de imágenes');
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      root.dataset.autoplay = String(!paused && !hovered && !focused && onScreen && visible());
      if (paused || hovered || focused || !onScreen || !visible()) return;
      timer = window.setInterval(() => {
        const next = slides[(current + 1) % slides.length];
        if (next.complete && next.naturalWidth) show(current + 1);
      }, 3000);
    }
    toggle.addEventListener('click', () => { paused = !paused; if (!paused) { hovered = false; focused = false; } sync(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); paused = true; sync(); }));
    root.addEventListener('mouseenter', () => { hovered = true; sync(); });
    root.addEventListener('mouseleave', () => { hovered = false; sync(); });
    root.addEventListener('focusin', () => { focused = true; sync(); });
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; sync(); } });
    document.addEventListener('visibilitychange', sync);
    const onMotionChange = () => { paused = motion.matches; sync(); };
    motion.addEventListener('change', onMotionChange);
    const observer = new IntersectionObserver(entries => {
      onScreen = entries.some(entry => entry.isIntersecting);
      if (!onScreen) { window.clearInterval(timer); timer = null; root.dataset.autoplay = 'false'; }
      else sync();
    });
    observer.observe(root);
    instances.set(root, () => {
      window.clearInterval(timer);
      observer.disconnect();
      document.removeEventListener('visibilitychange', sync);
      motion.removeEventListener('change', onMotionChange);
    });
    show(0);
    sync();
  }
  const initAll = () => document.querySelectorAll('[data-ad-carousel]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once: true});
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ad-carousel]').forEach(root => { instances.get(root)?.(); instances.delete(root); });
  });
})();
